import { Table } from '@anyemp/ui-kit';

const StatisticsTable = ({ footer, ...props }) => (
  <Table {...props} footer={footer} />
);

export default StatisticsTable;
